package diana.soleil.design.iraniancanadienbazzar.core.firebase

import dev.gitlive.firebase.storage.Data
import org.khronos.webgl.Int8Array
import org.khronos.webgl.Uint8Array

// Kotlin/JS ByteArray is backed by an Int8Array; reuse its buffer as a Uint8Array (no copy).
internal actual fun storageDataOf(bytes: ByteArray): Data {
    val int8 = bytes.unsafeCast<Int8Array>()
    return Data(Uint8Array(int8.buffer, int8.byteOffset, int8.length))
}
